import type { ContactDetails } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import {
    EligibilityRow,
    FieldList,
    MissingRow,
    ProfileSection,
} from "../profilePrimitives";
import { contactRows } from "../profileRows";
import { formatAddress, listMissingLabels } from "../profileUtils";

export function ContactSection({
    contact,
    setOverlay,
}: {
    contact: ContactDetails;
    setOverlay: OpenProfileOverlay;
}) {
    return (
        <ProfileSection
            title="Contact details"
            editable
            onEdit={() => setOverlay({ type: "edit", section: "contact" })}
        >
            <FieldList rows={contactRows(contact)} />
            <EligibilityRow eligibilityDetails={contact.eligibilityDetails} />
            <MissingRow
                labels={listMissingLabels([
                    { label: "Email", present: !!contact.email },
                    { label: "Phone", present: !!contact.phoneNumber },
                    {
                        label: "Preferred channel",
                        present: !!contact.preferredCommunicationChannel,
                    },
                    {
                        label: "Address",
                        present: !!formatAddress(contact),
                    },
                    {
                        label: "Eligibility",
                        present: !!(
                            contact.eligibilityDetails?.bin ||
                            contact.eligibilityDetails?.last4
                        ),
                    },
                ])}
            />
        </ProfileSection>
    );
}
